import {Router, ActivatedRoute, Params} from '@angular/router';
import { Component, OnInit, AfterViewInit,AfterViewChecked, ElementRef, NgModule, Pipe } from '@angular/core';
import { ReactiveFormsModule, FormsModule, FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { DesignerService } from '../../designer/designer.service';
import { CalenderService } from '../calender.service';
import { environment } from 'environments/environment';
import { LoaderService } from '../../../services/loader.service';

declare let $: any;

@Component({
  selector: 'app-viewcalender',
  templateUrl: './viewcalender.component.html',
  styleUrls: ['./viewcalender.component.css'],
  providers: [CalenderService,DesignerService]
})
export class ViewcalenderComponent implements OnInit {

  meetingform: FormGroup;
  updatemeetingform: FormGroup;
  markDoneform: FormGroup;
  statusChangeForm: FormGroup;
  statusDetails: any = {};
  todayDate = new Date(new Date().getTime() + 330*60000).toJSON().slice(0,19);
  public latestevent:any
  public leads:any = []
  public projectUsers:any
  public events:any = []
  public currentuser:any = localStorage.getItem("userId");
  public calElem:any = $('#calendar')
  public currentEvent:any
  errorMessage : string;
  erroralert = false;
  successalert = false;
  successMessage : string;
  designer_list:any;
  role:any;
  designerId;

  // Date
  date = new Date();
  y = this.date.getFullYear();
  m = this.date.getMonth();
  from_date:any = new Date(this.y, this.m, 1);
  to_date:any = new Date(this.y, this.m + 1, 0);

  constructor(
    public activatedRoute: ActivatedRoute,
    public calenderService : CalenderService,
    private loaderService:LoaderService,
    private designerService : DesignerService,
  ) { }

  ngOnInit() {
    this.role=localStorage.getItem('user');
    this.designerId = localStorage.getItem('userId');

    this.meetingform = new FormGroup({
      project: new FormControl(null, Validators.required),
      ownerable_type: new FormControl(null, Validators.required),
      agenda: new FormControl(null, Validators.required),
      contact_type: new FormControl(null, Validators.required),
      description: new FormControl(),
      scheduled_at: new FormControl(new Date(new Date().getTime() + 330*60000).toJSON().slice(0,19)),
      location: new FormControl(),
      email: new FormControl(null, Validators.required),
    });

    this.updatemeetingform = new FormGroup({
        project: new FormControl(null, Validators.required),
        ownerable_type: new FormControl(null, Validators.required),
        agenda: new FormControl(null, Validators.required),
        contact_type: new FormControl(null, Validators.required),
        description: new FormControl(),
        scheduled_at: new FormControl(),
        location: new FormControl(),
        remark: new FormControl(null, Validators.required),
        email: new FormControl(null, Validators.required),
      });
    this.markDoneform = new FormGroup({
        remark: new FormControl(null, Validators.required),
       
      });
    this.statusChangeForm = new FormGroup({
        reson_for_lost: new FormControl("",Validators.required),
        lost_remarks:new FormControl("")
      })
  }

  ngAfterViewInit(){
    this.calElem = $('#calendar');
    this.loaderService.display(true);

    this.calenderService.fetchLead().subscribe(
        leads => {
          // this.leads = leads;
          // this.leads = leads;
          Object.keys(leads).map((key)=>{ this.leads=leads[key];});
        },
        error => {
          console.log(error)
        }
      );

    this.fetchEvent(this.from_date, this.to_date);
    if(this.role != "designer"){
      this.calenderService.fetchDesigner(localStorage.getItem("userId")).subscribe(
        designers=>{
          this.designer_list = designers.designer_list;
        },
        error => {
          console.log("asdsad",error);
        }
      );
    }
  }

  fetchEvent(from_date, to_date){
    this.calenderService.fetchEvent(from_date, to_date).subscribe(
        events => {
          events = events;
          Object.keys(events).map((key)=>{ this.events=events[key]; });
          this.populateCalender();
          this.calElem.fullCalendar( 'removeEvents' )
          this.calElem.fullCalendar( 'addEventSource', this.events )
        },
        error => {
          console.log(error)
        }
      );
  }

  filterDesigner(event){
    this.calElem.fullCalendar( 'removeEvents' )
    var val = event.target.value;
    this.loaderService.display(true);
    this.calenderService.fetchDesignerEvent(val,this.from_date, this.to_date).subscribe(
      events=>{
        events = events;
          Object.keys(events).map((key)=>{ this.events= events[key];});
          // $(".calendar-container").html("<div id='calendar' #calendar></div>");
          // this.calElem = $("#calendar");
          // this.populateCalender();
          this.calElem.fullCalendar( 'addEventSource', this.events )
          this.loaderService.display(false);

      },
      error => {
        console.log(error);

      }
      );
  }
    reasonForLostDropdownChange(val){
      this.statusChangeForm.controls['lost_remarks'].setValidators([Validators.required]);  
      this.statusChangeForm.controls['lost_remarks'].updateValueAndValidity();
    }

  onStatusChange(status){
    this.statusDetails["customer_status"] = status;
      this.statusDetails["customer_id"] = this.current_user_id;
      this.statusDetails['project_id'] = this.current_project_id;
      
      this.loaderService.display(true);

      if(this.statusDetails["customer_status"] == "follow_up"){
        $("#followup-details").val(new Date(new Date().getTime() + 330*60000).toJSON().slice(0,19));
        // $("#followup_remarks").val();
        this.loaderService.display(false);
        $("#statusModal").modal("show");
      }else if(this.statusDetails["customer_status"] == "lost"){
        this.loaderService.display(false);
        $("#loststatusModal").modal("show");
      }
      else{
        this.updateNewStatus();
      }
  }
  onCallbackChange(status){
      this.loaderService.display(true);
      if(status=='lost'){
        $("#loststatusModal").modal("hide");
        this.statusDetails["reason_for_lost"] = $("#lost_reason").val();
        this.statusDetails['remarks']= $("#lost_remarks").val();
        this.updateNewStatus();

      }
      if(status=='follow_up'){
        if($("#followup-details").val() != ''){
         $("#statusModal").modal("hide");
        this.statusDetails["customer_meeting_time"] = $("#followup-details").val();
        this.statusDetails['remarks']= $("#followup_remarks").val();
        this.updateNewStatus();
        }
        else{
          this.loaderService.display(false);
          this.erroralert = true;
            this.errorMessage = 'CallBack Date is required';
            setTimeout(function() {
                  this.erroralert = false;
               }.bind(this), 2000);
              
        }
      }
    }
    updateNewStatus(){
      this.designerService.statusUpdate(this.statusDetails,this.designerId).subscribe(
          res => {

            this.loaderService.display(false);
            this.successalert = true;
            this.successMessage = 'Status updated successfully!';
            this.statusChangeForm.reset();
            this.statusChangeForm.controls['reson_for_lost'].setValue("");
            // if(document.getElementById('lostRemarkRow')){
            //   document.getElementById('lostRemarkRow').classList.add('d-none');
            // }
            setTimeout(function() {
                   this.successalert = false;
              }.bind(this), 2000);
            $('#viewEventModal').modal("hide");
            $('#statusModal').modal("hide");
            this.repopulateCalendar();
              
          },
          err => {

            this.erroralert = true;
            this.loaderService.display(false);
              this.errorMessage = JSON.parse(err['_body']).message;
              setTimeout(function() {
                   this.erroralert = false;
              }.bind(this), 2000);

          }
      )
    }

  getFromTo(date){
    this.y = date.getFullYear();
    this.m = date.getMonth();
    this.from_date = new Date(this.y, this.m, 1);
    this.to_date = new Date(this.y, this.m + 1, 0);

    this.fetchEvent(this.from_date, this.to_date);
    // this.calElem.fullCalendar("refetchEvents");

    // this.calElem.fullCalendar( 'removeEvents' )
    // this.calElem.fullCalendar( 'addEventSource', this.events )

  }

  current_project_id;
  current_user_id;
  cal_lead_id;
  populateCalender(){
    this.calElem = $('#calendar');
    var parentThis = this
    this.calElem.fullCalendar({
      customButtons: {
        Prev: {
          text: 'Prev',
          click: function(calEvent) {
            parentThis.calElem.fullCalendar("prev");
            parentThis.calElem.fullCalendar( 'removeEvents' )
            parentThis.getFromTo(parentThis.calElem.fullCalendar('getDate')._d);
            
          }
        },
        Next: {
          text: 'Next',
          click: function(calEvent) {
            parentThis.calElem.fullCalendar("next");
            parentThis.calElem.fullCalendar( 'removeEvents' )
            parentThis.getFromTo(parentThis.calElem.fullCalendar('getDate')._d);
          }
        },
        Today: {
          text: 'Today',
          click: function(calEvent) {
            parentThis.calElem.fullCalendar("today");
            parentThis.calElem.fullCalendar( 'removeEvents', parentThis.events )
            parentThis.getFromTo(parentThis.calElem.fullCalendar('getDate')._d);
          }
        }
      },

      header: {
        left:   'Today Prev,Next',
        center: 'title',
        right:  'month basicWeek basicDay'
      },
      navLinks: true,
      dayClick: function(date, jsEvent, view){
        //alert('Clicked on: ' + date.format());

        // alert('Coordinates: ' + jsEvent.pageX + ',' + jsEvent.pageY);

        // alert('Current view: ' + view.name);

        // $(this).css('background-color', 'red');
        parentThis.meetingform.controls['scheduled_at'].setValue(new Date(date._i).toJSON().slice(0,19));
        $("#eventModal").modal("show");
      },

      events: this.events,
      // events: [{id: 8, title: "12:12PM / briefing_sales_pitch", start: "2018-02-21"},{id: 9, title: "12:13PM / briefing_sales_pitch", start: "2018-02-21"}],
      eventClick:function( calEvent, jsEvent, view ) {
        $("#viewEventModal").modal("show");
        parentThis.currentEvent = calEvent;
        if(calEvent.location == null){
          calEvent.location = "None"

        }
        if(calEvent.description == null){
          calEvent.description = "None"

        }
        parentThis.current_project_id=calEvent.ownerable_id;
        parentThis.current_user_id = calEvent.customer_id;
        parentThis.cal_lead_id = calEvent.lead_id;
        $(".modal-project").html("<p style = 'padding-top: .35rem!important;'>"+calEvent.ownerable_name+"</p>");
        $(".modal-agenda").html("<p style = 'padding-top: .35rem!important;'>"+calEvent.agenda.split('_').join(' ')+"</p>");
        if(calEvent.agenda == 'follow_up'){
          $('#furemark-hide').show();
        }
        else{
          $('#furemark-hide').hide();
        }
        if(calEvent.agenda == 'follow_up' || calEvent.agenda == 'follow_up_for_not_contactable' ){
          $('#designer-hide').hide();
        }
        else{
          $('#designer-hide').show();
        }
        if(calEvent.agenda == 'follow_up' || calEvent.agenda == 'follow_up_for_not_contactable'  || calEvent.agenda == 'lead_assigned'){

          $('#status-change').show();
        }
        else{

           $('#status-change').hide();
        }
        $(".modal-type").html("<p style = 'padding-top: .35rem!important;'>"+calEvent.contact_type.split('_').join(' ')+"</p>");
        $(".modal-description").html("<p style = 'padding-top: .35rem!important;'>"+calEvent.description+"</p>");
        $(".modal-date").html("<p style = 'padding-top: .35rem!important;'>"+calEvent.datetime+"</p>");
        $(".modal-location").html("<p style = 'padding-top: .35rem!important;'>"+calEvent.location+"</p>");
        $(".modal-members").html("<p style = 'padding-top: .35rem!important;'>"+calEvent.users.join("<br/>")+"</p>");
        $(".modal-status").html("<p style = 'padding-top: .35rem!important;'>"+calEvent.status+"</p>");
        $(".modal-remark").html("<p style = 'padding-top: .35rem!important;'>"+calEvent.remark+"</p>");
        
        $(".modal-furemark").html("<p style = 'padding-top: .35rem!important;'>"+calEvent.ownerable_remark+"</p>");

        $(".modal-lead").html("<p style = 'padding-top: .35rem!important;'>"+calEvent.customer_name+"</p>");
        $(".modal-designer").html("<p style = 'padding-top: .35rem!important;'>"+calEvent.designer.name +"-"+calEvent.designer.email+"</p>");
        
        if(calEvent.status == 'done'){
          $('#btn-hide').css({ 'display' : 'none'});
          $('#btn-hides').css({ 'display' : 'none'});
          $('#remark-hide').show();
          $('#status-change').hide();
        }
        else if(calEvent.status == 'rescheduled'){
          $('#remark-hide').show();
          $('#btn-hide').css({ 'display' : 'block'});
          $('#btn-hides').css({ 'display' : 'block'});

        }

        
        else{
          $('#btn-hide').css({ 'display' : 'block'});
          $('#btn-hides').css({ 'display' : 'block'});
          $('#remark-hide').hide();

        }

        parentThis.updatemeetingform.controls['project'].setValue(calEvent.ownerable_id);
        parentThis.updatemeetingform.controls['ownerable_type'].setValue(calEvent.ownerable_type);
        parentThis.updatemeetingform.controls['agenda'].setValue(calEvent.agenda);
        parentThis.updatemeetingform.controls['contact_type'].setValue(calEvent.contact_type);
        parentThis.updatemeetingform.controls['description'].setValue(calEvent.description);
        parentThis.updatemeetingform.controls['scheduled_at'].setValue(new Date(Date.parse(calEvent.scheduled_at) + 330*60000).toJSON().slice(0,19));
        parentThis.updatemeetingform.controls['location'].setValue(calEvent.location);
        parentThis.updatemeetingform.controls['remark'].setValue(calEvent.remark);
        parentThis.updatemeetingform.controls['email'].setValue(calEvent.users.join(";"));
        // console.log("calEvent",calEvent);
        // console.log("jsEvent",jsEvent);
        // console.log("view",view);
        // if (calEvent.title) {
        //     alert(calEvent.title);
        //     // return false;
        // }
      },

      selectable: true,
      eventBackgroundColor: '#A73E57',
      eventBorderColor: '#A73E57',
      eventTextColor: '#ffffff'

    });
    this.loaderService.display(false);
  }

  createEvent(){
    var parentThis = this
    if (this.meetingform.valid) {
      this.loaderService.display(true);
      this.calenderService.createEvent(this.meetingform.value).subscribe(
        event => {
          event = event;
          Object.keys(event).map((key)=>{ this.latestevent= event[key];});
          this.repopulateCalendar();
          // this.calenderService.fetchEvent().subscribe(
          //   events => {
          //     events = events;
          //     this.events = [];
          //     Object.keys(events).map((key)=>{ this.events=events[key]; });
          //     // this.populateCalender();
          //     this.calElem.fullCalendar( 'rerenderEvents' );
          //   },
          //   error => {
          //     console.log(error)
          //   }
          // );
         setTimeout(function() {
             this.successalert = false;
          }.bind(this), 2000);
          //this.router.navigateByUrl('/projects/'+project.id+'/floorplan/create');
          // return presentation;
          this.successalert = true;
          this.successMessage = "Event successfully created";
          this.loaderService.display(false);
          setTimeout(function() {
             this.successalert = false;
          }.bind(this), 2000);
        },
        error => {
          // return Observable.throw(error);
          this.erroralert = true;
          this.errorMessage = "Some error occured while creating an event";
          // this.errorMessage = JSON.parse(error['_body']).message;
          // alert("Error creating event");
          this.loaderService.display(false);
          setTimeout(function() {
              this.erroralert = false;
           }.bind(this), 2000);
        }
      );
      this.meetingform.reset();
      $("#eventModal").modal("hide");
    }
  }

  repopulateCalendar(){
    this.calElem.fullCalendar( 'removeEvents' )
    this.calenderService.fetchEvent(this.from_date, this.to_date).subscribe(
      events => {
        events = events;
        Object.keys(events).map((key)=>{ this.events=events[key]; });
        // $(".calendar-container").html("<div id='calendar' #calendar></div>");
        this.calElem.fullCalendar( 'addEventSource', this.events )
        // this.calElem = $("#calendar");
        // this.populateCalender();
        // this.calElem.fullCalendar( 'refetchEvents' );
      },
      error => {
        console.log(error)
      }
    );
  }

  updateStatus(status){
    var calEvent = this.currentEvent;
    if(status == "reschedule"){
      this.updatemeetingform.controls['project'].setValue(calEvent.ownerable_id);
      this.updatemeetingform.controls['ownerable_type'].setValue(calEvent.ownerable_type);
      this.updatemeetingform.controls['agenda'].setValue(calEvent.agenda);
      this.updatemeetingform.controls['contact_type'].setValue(calEvent.contact_type);
      this.updatemeetingform.controls['description'].setValue(calEvent.description);
      this.updatemeetingform.controls['remark'].setValue(calEvent.remark);
      this.updatemeetingform.controls['scheduled_at'].setValue(new Date(calEvent.scheduled_at).toJSON().slice(0,19));
      this.updatemeetingform.controls['location'].setValue(calEvent.location);
      this.updatemeetingform.controls['email'].setValue(calEvent.users.join(";"));

      $("#updateEventModal").modal("show");
    }
    else if(status == "done"){
      $("#markModal").modal("show");
      
      
    }
  }
  remarkEvent(){
    var calEvent = this.currentEvent;
    if(this.markDoneform.valid){
     this.calenderService.updateStatus(this.markDoneform.value,calEvent.id).subscribe(
        event => {
          event = event;
          this.successalert = true;
          this.successMessage = "Event  Marked as Done";
          $("#updateEventModal").modal("hide");
          $("#viewEventModal").modal("hide");
          $("#markModal").modal("hide");
          this.repopulateCalendar();
        },
        error => {
          this.erroralert = true;
          this.errorMessage = "Error updating event";
          console.log(error)
        }
      );
    }
  }

  updateEvent(){
    var calEvent = this.currentEvent;
    if (this.updatemeetingform.valid) {
      this.calenderService.updateEvent(this.updatemeetingform.value, calEvent.id).subscribe(
        event => {
          event = event;
          this.successalert = true;
          this.successMessage = "Event updated";
          $("#updateEventModal").modal("hide");
          $("#viewEventModal").modal("hide");
          this.repopulateCalendar();
        },
        error => {
          this.erroralert = true;
          this.errorMessage = "Error updating event";
          console.log(error)
        }
      );
      this.meetingform.reset();
      $("#eventModal").modal("hide");
    }
  }

  onProjectChange(val){
    for(let lead of this.leads){
      if(lead.ownerable_id == val){
        this.meetingform.controls['ownerable_type'].setValue(lead.ownerable_type);
        this.updatemeetingform.controls['ownerable_type'].setValue(lead.ownerable_type);
      }
    }




    this.calenderService.fetchUsers(val).subscribe(
      users => {
        Object.keys(users).map((key)=>{ this.projectUsers= users[key];});
      },
      error => {
        this.erroralert = true;
        this.errorMessage = "Error updating event";
        console.log(error)
      }
    );
  }

  onMeetingUserChange(event,target){
    var val = event.target.value
    if(target == "meeting"){
      var exist_value = $(".meeting-control").val();
    }
    else if (target == "update") {
      var exist_value = $(".update-control").val();
    }
    var new_val;
    if(event.srcElement.checked){
      if(exist_value != undefined && exist_value != "" && exist_value != null){
        new_val = exist_value+";"+val;
      }
      else{
        new_val = val;
      }
    }
    else{
      if(exist_value != undefined && exist_value != "" && exist_value != null){
        var arr = exist_value.split(";");
        var index = arr.indexOf(val, 0);
        if (index > -1) {
           arr.splice(index, 1);
        }
        new_val = arr.join(";");
      }
    }
    if(target == "meeting"){
      $(".meeting-control").val(new_val);
      this.meetingform.controls['email'].setValue(new_val);
    }
    else if (target == "update") {
      $(".update-control").val(new_val);
      this.meetingform.controls['email'].setValue(new_val);
    }

  }
  month:any;
  day:any;
  year:any
  // Disable calender date
  disableDate(){
    var datep = $('#followup-details').val();
    datep = datep.substring(0,10);

    var dtToday = new Date();
      
     this.month = dtToday.getMonth() + 1;
     this.day = dtToday.getDate();
     this.year = dtToday.getFullYear();
    if(this.month < 10)
        this.month = '0' + this.month.toString();
    if(this.day < 10)
        this.day = '0' + this.day.toString();
    
    var maxDate = this.year + '-' + this.month + '-' + this.day;
    $('#followup-details').attr('min', maxDate);
    if (datep < maxDate) {
      alert("selected date is in past");
      $('#followup-details').val(maxDate);
    }
    

  }

  actionable_Filter(actionable_of){
    this.loaderService.display(true);
    this.calElem.fullCalendar( 'removeEvents' )
    this.calenderService.fetchEvent(this.from_date, this.to_date, actionable_of).subscribe(
      events => {
        events = events;
        Object.keys(events).map((key)=>{ this.events=events[key]; });
        // $(".calendar-container").html("<div id='calendar' #calendar></div>");
        // this.calElem = $("#calendar");
        // this.populateCalender();
        this.calElem.fullCalendar( 'addEventSource', this.events )
        // this.calElem.fullCalendar( 'refetchEvents' );
        this.loaderService.display(false);
      },
      error => {
        console.log(error)
        this.loaderService.display(false);
      }
    );
  }
  callResponse: any;
  callToLead(leadId){
    this.loaderService.display(true);
    this.designerService.callToLead(localStorage.getItem('userId'), leadId).subscribe(
        res => {
           this.loaderService.display(false);
          if(res.inhouse_call.call_response.code == '403'){
            this.erroralert = true;
            this.errorMessage = JSON.parse(res.message.body).RestException.Message;
            setTimeout(function() {
                 this.erroralert = false;
            }.bind(this), 10000);
            //JSON.parse(temp1.body).RestException.Message
          } else {
            this.callResponse =  JSON.parse(res.inhouse_call.call_response.body);
            this.successalert = true;
            this.successMessage = 'Calling from - '+this.callResponse.Call.From;
            setTimeout(function() {
                 this.successalert = false;
            }.bind(this), 10000);
          }
        },
        err => {
          this.loaderService.display(false);
          console.log(err);
        }
     );
  }
  callFromCalenderToLead(){
    this.callToLead(this.cal_lead_id);
  }

}



// WEBPACK FOOTER //
// /Users/shobhit/Documents/codes/arrivae-frontend/src/app/platform/calender/viewcalender/viewcalender.component.ts